import type { AppUserData, IPagination, ISearchable, IUser } from 'shared/types'
import { client } from '../clients'

const createRecord = (record: IUser) => client.post('/users', record)

const getList = (page: number) => client.get<IPagination<IUser>>('/users', {
  params: { page }
})

const getMe = () => client.get<AppUserData>('/users/me')

const getRecord = (recordId: string) => client.get<IUser>(`/users/${recordId}`)

const updateRecord = (record: IUser) =>
  client.put(`/users/${record.id}`, record)

const removeRecord = (recordId: string) => client.delete(`/users/${recordId}`)

const search = (params: ISearchable) => client.get<IUser[]>('/users/all', {
  params
})

export const users = {
  record: {
    create: createRecord,
    get: getRecord,
    update: updateRecord,
    remove: removeRecord
  },
  getList,
  getMe,
  search
}
